'use client';

export { default } from './components/contact-us';
